export default Promise
